var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { XForm } from "@bluelibs/x-ui-admin";
import { Service } from "@bluelibs/core";
import * as Ant from "antd";
import { CompaniesCollection, BanksCollection, UsersCollection, } from "@bundles/UIAppBundle/collections";
import { BankAccountCurrency } from "@bundles/UIAppBundle/collections/BankAccounts/enum";
import { UserRole } from "@root/api.types";
let BankAccountListFiltersForm = class BankAccountListFiltersForm extends XForm {
    build(userRoles) {
        const { UIComponents } = this;
        const { t } = this.i18n;
        this.add([
            {
                id: "createdAt",
                label: t("management.bank_accounts.fields.createdAt"),
                name: ["createdAt"],
                tooltip: t("management.bank_accounts.fields.createdAt_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "updatedAt",
                label: t("management.bank_accounts.fields.updatedAt"),
                name: ["updatedAt"],
                tooltip: t("management.bank_accounts.fields.updatedAt_description"),
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.DatePicker.RangePicker, {}, void 0) }), void 0)),
            },
            {
                id: "accountNumber",
                label: t("management.bank_accounts.fields.accountNumber"),
                name: ["accountNumber"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Input, {}, void 0) }), void 0)),
            },
            {
                id: "currency",
                label: t("management.bank_accounts.fields.currency"),
                name: ["currency"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Select, Object.assign({ mode: "multiple", placeholder: t("management.bank_accounts.fields.currency") }, { children: Object.keys(BankAccountCurrency).map((currency, index) => (_jsx(Ant.Select.Option, Object.assign({ value: currency }, { children: currency }), currency))) }), void 0) }), void 0)),
            },
            {
                id: "initialBalance",
                label: t("management.bank_accounts.fields.initialBalance"),
                name: ["initialBalance"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(Ant.Slider, { range: true, step: 10, min: 0, max: 100000 }, void 0) }), void 0)),
            },
            {
                id: "companyId",
                label: t("management.bank_accounts.fields.company"),
                name: ["companyId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: CompaniesCollection, field: "name", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
            },
            {
                id: "bankId",
                label: t("management.bank_accounts.fields.bank"),
                name: ["bankId"],
                render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: BanksCollection, field: "name", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
            },
            ...(userRoles.includes(UserRole.ADMIN)
                ? [
                    {
                        id: "createdById",
                        label: t("management.bank_accounts.fields.createdBy"),
                        name: ["createdById"],
                        tooltip: t("management.bank_accounts.fields.createdBy_description"),
                        render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
                    },
                    {
                        id: "updatedById",
                        label: t("management.bank_accounts.fields.updatedBy"),
                        name: ["updatedById"],
                        tooltip: t("management.bank_accounts.fields.updatedBy_description"),
                        render: (props) => (_jsx(Ant.Form.Item, Object.assign({}, props, { children: _jsx(UIComponents.RemoteSelect, { collectionClass: UsersCollection, field: "fullName", placeholder: "Please select an option", mode: "multiple" }, void 0) }), void 0)),
                    },
                ]
                : []),
        ]);
    }
};
BankAccountListFiltersForm = __decorate([
    Service({ transient: true })
], BankAccountListFiltersForm);
export { BankAccountListFiltersForm };
